import { combineReducers } from 'redux';
import deliverySlots from 'fk-cp-common-components/reducers/scheduleDeliveryReducer';
import dogfoodingData from 'fk-cp-common-components/reducers/dogFoodingReducer';
import ifscFinderData from 'fk-cp-common-components/reducers/ifscFinderReducer';
import myOrders from 'fk-cp-common-components/reducers/myOrdersReducer';
import myOrdersV2 from 'fk-cp-common-components/reducers/myOrdersReducerV2';
import filters from 'fk-cp-common-components/reducers/FiltersReducer';
import orderAddress from './orderAddressReducer';
import orderCancellation from 'fk-cp-common-components/reducers/orderCancellationReducer';
import orderConfirmationPage from 'fk-cp-common-components/reducers/orderConfirmationReducer';
import orderConfirmationPagePS2 from 'fk-cp-common-components/reducers/orderConfirmationReducerPS2';
import orderConfirmationReco from 'fk-cp-common-components/reducers/orderConfirmationRecoReducer';
import postOrderDetailsV2 from 'fk-cp-common-components/reducers/orderDetailsReducerV2';
import postOrderDetails from 'fk-cp-common-components/reducers/orderDetailsReducer';
import returnAddress from './returnAddressReducer';
import returns from 'fk-cp-common-components/reducers/returnsReducer';
import trackOrder from 'fk-cp-common-components/reducers/trackOrderReducer';
import bnplData from 'fk-cp-common-components/reducers/bnplReducer';
import subscribeUnsubscribeData from 'fk-cp-common-components/reducers/subscribeUnsubscribeReducer';
import returnVisualState from 'fk-cp-common-components/reducers/returnVisualStateReducer';
import returnToken from './returnToken';
import neftData from 'fk-cp-common-components/reducers/neftReducer';
import neftIfscFinderData from 'fk-cp-common-components/reducers/neftIfscFinderReducer';
import cancelReturnData from 'fk-cp-common-components/reducers/cancelReturnReducer';
import payNow from 'fk-cp-common-components/reducers/payNowReducer';
import ndrData from 'fk-cp-common-components/reducers/NDRReducer';
import reschedule from 'fk-cp-common-components/reducers/rescheduleReducer';
import addressChange from 'fk-cp-common-components/reducers/addressChangeReducer';
import appContext from 'fk-cp-common-components/reducers/appContextReducer';
import fileManager from 'fk-cp-common-components/reducers/FileManagerReducer';
import imageInstructions from 'fk-cp-common-components/reducers/imageInstructionsReducer';
import prexoChecks from 'fk-cp-common-components/reducers/prexoChecksReducer';
import serviceListing from 'fk-cp-common-components/reducers/serviceListingReducer';
import payNowPreorder from 'fk-cp-common-components/reducers/preorderPayNowReducer';
import userInfo from 'fk-cp-common-components/reducers/userStateReducer';
import blobIO from 'fk-cp-common-components/reducers/blobIOReducer';
import issues from 'fk-cp-common-components/reducers/issuesReducer';
import nudges from 'fk-cp-common-components/reducers/nudgeReducer';
import issueDetails from 'fk-cp-common-components/reducers/issueDetailsReducer';

export default combineReducers({
	appContext,
	deliverySlots,
	dogfoodingData,
	ifscFinderData,
	myOrders,
	myOrdersV2,
	filters,
	orderAddress,
	orderCancellation,
	orderConfirmationPage,
	orderConfirmationPagePS2,
	orderConfirmationReco,
	postOrderDetails,
	postOrderDetailsV2,
	returnAddress,
	returns,
	trackOrder,
	bnplData,
	subscribeUnsubscribeData,
	returnVisualState,
	returnToken,
	neftData,
	neftIfscFinderData,
	cancelReturnData,
	payNow,
	ndrData,
	reschedule,
	addressChange,
	fileManager,
	imageInstructions,
	serviceListing,
	payNowPreorder,
	prexoChecks,
	issues,
	issueDetails,
	userInfo,
	blobIO,
	nudges
});
